// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';
import PasajeroView from '@/views/PasajeroView.vue';
import RecogidaView from '@/views/RecogidaView.vue'; 
import PoliticasView from '@/views/PoliticasView.vue';
import TransferView from '@/views/TransferView.vue';
import TransferDashboard from '@/views/TransferDashboard.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue')
  },
  {
  path: '/transfers',
  name: 'TransferView',
  component: TransferView,
  },
  {
  path: '/dashboard-transferencias',
  name: 'TransferDashboard',
  component: TransferDashboard,
  },
  {
    path: '/politicas',
    name: 'Politicas',
    component: PoliticasView
  },
  {
    path: '/:encodedParam',
    name: 'Pasajero',
    component: PasajeroView,
    props: true // Pasa encodedParam como prop al componente
  },
  {
    path: '/recogida/:encodedParam',
    name: 'Recogida',
    component: RecogidaView,
    props: true
  },
];

const router = new VueRouter({
  mode: 'history', // Requiere configuración en Nginx (ya la tienes con try_files)
  routes
});

export default router;